export const Button = {
  variants: {
    main: {
      bg: 'var(--btn)',
      color: 'var(--btn-alt)',
      borderColor: 'var(--btn)',
      _hover: {
        color: 'var(--btn-alt)',
        opacity: 0.9,
        _disabled: {
          bg: 'var(--btn)',
          color: 'var(--btn-alt)',
          borderColor: 'var(--btn)',
          opacity: 0.4
        }
      },
      _focus: {
        color: 'var(--btn-alt)',
        opacity: 0.8
      },
      _active: {
        color: 'var(--btn-alt)',
        opacity: 1
      }
    },
    'main-alt': {
      bg: 'var(--btn-alt)',
      color: 'var(--btn)',
      borderColor: 'var(--btn-alt)',
      _hover: {
        color: 'var(--btn)',
        opacity: 0.9
      },
      _focus: {
        color: 'var(--btn)',
        opacity: 0.8
      },
      _active: {
        color: 'var(--btn)',
        opacity: 1
      }
    },
    outline: {
      bg: 'transparent',
      color: 'var(--btn)',
      borderColor: 'var(--btn)',
      _hover: {
        bg: 'transparent',
        color: 'var(--btn)',
        borderColor: 'var(--btn)',
        opacity: 0.9
      },
      _focus: {
        bg: 'transparent',
        color: 'var(--btn)',
        borderColor: 'var(--btn)',
        opacity: 0.8
      },
      _active: {
        bg: 'transparent',
        color: 'var(--btn)',
        borderColor: 'var(--btn)',
        opacity: 0.7
      }
    },
    'line-alt': {
      bg: 'transparent',
      color: 'var(--btn-alt)',
      borderColor: 'var(--btn-alt)',
      _hover: {
        opacity: 0.9
      },
      _focus: {
        opacity: 0.8
      },
      _active: {
        opacity: 0.7
      }
    },
    ghost: {
      bg: 'transparent',
      color: 'var(--text)',
      borderColor: 'transparent',
      opacity: 0.7,
      _hover: {
        opacity: 0.8,
        color: 'var(--text)',
        bg: 'var(--ghost)'
      },
      _focus: {
        opacity: 0.8,
        color: 'var(--text)',
        bg: 'var(--ghost)'
      },
      _active: {
        opacity: 1,
        color: 'var(--text)',
        bg: 'var(--ghost)'
      }
    },
    secondary: {
      bg: 'transparent',
      color: 'var(--text)',
      borderWidth: 0,
      _hover: {
        opacity: 0.7
      },
      _focus: {
        opacity: 0.7
      },
      _active: {
        opacity: 1
      }
    },
    link: {
      bg: 'transparent',
      color: 'var(--link)',
      borderColor: 'transparent',
      _hover: {
        opacity: 0.9
      },
      _focus: {
        opacity: 0.8
      },
      _active: {
        opacity: 0.7
      }
    },
    'link-alt': {
      bg: 'transparent',
      color: 'var(--link-alt)',
      borderColor: 'transparent',
      _hover: {
        opacity: 0.9
      },
      _focus: {
        opacity: 0.8
      },
      _active: {
        opacity: 0.7
      }
    },
    transparent: {
      bg: 'transparent',
      color: 'var(--link)',
      borderColor: 'transparent',
      _hover: {
        opacity: 0.9
      },
      _focus: {
        opacity: 0.8
      },
      _active: {
        opacity: 0.7
      }
    },
    error: {
      bg: 'var(--error)',
      color: 'var(--error-alt)',
      borderColor: 'var(--error)',
      _hover: {
        opacity: 0.9,
        _disabled: {
          bg: 'var(--error)',
          color: 'var(--error-alt)',
          borderColor: 'var(--error)',
          opacity: 0.6
        }
      },
      _focus: {
        opacity: 0.8
      },
      _active: {
        opacity: 0.7
      }
    },
    tab: {
      bg: 'var(--front)',
      color: 'var(--muted)',
      borderColor: 'var(--border)',
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
      borderBottomWidth: 0,
      _hover: {
        color: 'var(--muted)'
      },
      _focus: {
        color: 'var(--muted)'
      },
      _active: {
        color: 'var(--muted)'
      }
    },
    'tab-alt': {
      bg: 'transparent',
      color: 'var(--muted)',
      borderColor: 'transparent',
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
      borderBottomWidth: 0,
      opacity: 0.7,
      _hover: {
        opacity: 0.8,
        color: 'var(--muted)',
        bg: 'var(--ghost)'
      },
      _focus: {
        opacity: 0.8,
        color: 'var(--muted)',
        bg: 'var(--ghost)'
      },
      _active: {
        opacity: 1,
        color: 'var(--muted)',
        bg: 'var(--ghost)'
      }
    },
    keyword: {
      bg: 'transparent',
      color: 'var(--muted)',
      borderColor: 'var(--ghost)',
      borderWidth: '1px',
      h: '24px',
      px: '8px',
      fontSize: 'xs',
      borderRadius: 'full',
      _hover: {
        color: 'var(--muted)',
        opacity: 0.9
      },
      _focus: {
        color: 'var(--muted)',
        opacity: 0.9
      },
      _active: {
        color: 'var(--muted)',
        opacity: 0.9
      }
    },
    warning: {
      bg: 'var(--warning)',
      color: 'var(--warning-alt)',
      borderColor: 'var(--warning)',
      _hover: {
        opacity: 0.9
      },
      _focus: {
        opacity: 0.8
      },
      _active: {
        opacity: 0.7
      }
    },
    success: {
      bg: 'var(--success)',
      color: 'var(--success-alt)',
      borderColor: 'var(--success)',
      _hover: {
        opacity: 0.9
      },
      _focus: {
        opacity: 0.8
      },
      _active: {
        opacity: 0.7
      }
    },
    picker: {
      color: 'var(--btn-alt)',
      borderColor: 'transparent',
      borderRadius: '5px',
      _hover: {
        opacity: 0.8
      },
      _focus: {
        opacity: 0.6
      },
      _active: {
        opacity: 0.6
      }
    }
  },
  sizes: {
    xs: {
      h: '24px',
      px: '8px',
      fontSize: '2xs',
      textTransform: 'uppercase',
      letterSpacing: '0.5px'
    },
    sm: {
      h: '28px',
      px: '12px',
      fontSize: 'xs'
    },
    md: {
      h: '32px',
      px: '16px',
      fontSize: 'sm'
    },
    lg: {
      h: '40px',
      px: '24px',
      fontSize: 'md'
    },
    xl: {
      h: '58px',
      px: '36px',
      fontSize: 'md'
    }
  },
  baseStyle: {
    borderRadius: '3px',
    border: '1px solid',
    textAlign: 'center',
    lineHeight: 1,
    _focus: {
      boxShadow: 'none'
    },
    _active: {
      opacity: '0.8'
    }
  },
  defaultProps: {
    variant: 'main',
    size: 'md'
  }
}
